<template>
  <div>
    <iframe ref="iframe" id="show-iframe" scrolling="auto" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: "conference",
  props:['http'],
  data() {
    return {
      current: 0,
    };
  },
  created() {
  },
  mounted() {
    this.getUrl();
  },
  methods: {
    getUrl() {
      this.$refs.iframe.contentWindow.location.replace(this.http);
    },
  }
};
</script>
 
<style lang="scss">
#show-iframe{position: absolute;}
</style>